<template>
  <v-card class="bg-gray" style="max-width: 440px; border-radius: 12px">
    <div v-if="news">
      <NuxtImg
        v-if="news.image_1"
        :src="news.image_1"
        :alt="news.image1_desc"
        class="image"
        format="webp"
        quality="80"
        loading="lazy"
      />
      <img
        v-else
        :src="PlaceholderImage"
        :alt="news.image1_desc"
        class="image"
        loading="lazy"
        decoding="async"
      />

      <div
        class="bg-gray w-100 px-15 py-11 content"
        style="border-radius: 14px"
      >
        <v-chip
          class="bg-primary text-body-2 font-weight-medium px-4"
          size="large"
        >
          {{ news.type_name }}
        </v-chip>
        <div class="text-h6 my-4 title-news" style="line-height: 2.5rem">
          {{ isIndonesia() ? news.title_id : news.title_en }}
        </div>
        <div class="text-body-1">
          {{ formatDate(news.createdon, "date-en") }}
        </div>

        <!-- CTA -->
        <router-link
          :to="
            isIndonesia()
              ? `/id/berita/${news.slug_id}`
              : `/en/news/${news.slug_en}`
          "
          @click="readMore(news)"
          class="text-decoration-none text-white"
        >
          <v-btn
            variant="outlined"
            class="mt-12 text-capitalize"
            style="border-radius: 14px"
          >
            {{ lang("homeNewsCTADetail") }}
            <span class="sr-only">
              {{ isIndonesia() ? news.title_id : news.title_en }}
            </span>
          </v-btn>
        </router-link>
      </div>
    </div>

    <div v-else>
      <v-skeleton-loader type="image" />

      <div class="bg-gray w-100 rounded-t-xl px-15 py-11 content">
        <v-skeleton-loader
          type="chip, ossein, heading, text@2, ossein, button"
          class="loader-article"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import PlaceholderImage from "@/assets/images/home/news/news_Paylater.webp";

import { mapActions } from "pinia";
import { useGeneralStore } from "@/stores/GeneralStore";
import { useTrackAnalyticsStore } from "@/stores/TrackAnalyticsStore";

export default {
  name: "NewsSideCard",
  props: {
    news: Object,
  },
  methods: {
    ...mapActions(useGeneralStore, ["setActivePage"]),
    ...mapActions(useTrackAnalyticsStore, ["saveTrackAnalytics"]),

    readMore(news) {
      const activePage = isIndonesia()
        ? `/id/berita/${news.slug_id}`
        : `/en/news/${news.slug_en}`;
      this.setActivePage(activePage);

      // Track Analytics
      const params = {
        action: "CLICK NEWS READ MORE",
        remark: "Click Latest News Read More",
        val1: null,
        val2: null,
        val3: activePage,
        val4: null,
        val5: null,
      };

      this.saveTrackAnalytics(params);
    },
  },
};
</script>

<style scoped>
::v-deep .v-skeleton-loader__image {
  height: 360px;
  z-index: 0;
}
.image {
  width: 100%;
  height: 100%;
  max-height: 360px;
}
.content {
  transform: translateY(-30px);
}
.loader-article {
  background-color: transparent;
}
.title-news {
  overflow: hidden;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
}
</style>
